/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ClientClipsByMediumTypeAnalyticsResponse { 
    mediumType?: ClientClipsByMediumTypeAnalyticsResponse.MediumTypeEnum;
    clipsCount?: number;
}
export namespace ClientClipsByMediumTypeAnalyticsResponse {
    export type MediumTypeEnum = 'PRINTED' | 'WEB' | 'TV' | 'RADIO' | 'SOCIAL';
    export const MediumTypeEnum = {
        PRINTED: 'PRINTED' as MediumTypeEnum,
        WEB: 'WEB' as MediumTypeEnum,
        TV: 'TV' as MediumTypeEnum,
        RADIO: 'RADIO' as MediumTypeEnum,
        SOCIAL: 'SOCIAL' as MediumTypeEnum
    };
}